import { makeStyles } from "@material-ui/core";

export default makeStyles(theme => {
  return {
    drawer: {
      position: "relative",
      flexShrink: 0,
      width: "250px",
      zIndex: theme.zIndex.drawer - 2,
      opacity: "1"
    },
    drawerPaper: {
      paddingTop: props => (props.navmenu.variant === "temporary" ? 0 : "40px"),
      width: "250px",
      zIndex: theme.zIndex.drawer - 2,
      color: theme.palette.getContrastText(theme.palette.background.default)
    },
    item: {
      width: "100%"
    },
    badge: {
      width: "20%"
    },
    icon: {
      color: theme.palette.text.hint
    },
    label: {
      userSelect: "none"
    },
    simtopyIcon: {
      height: 30
    },
    boxlayout: {
      display: "flex",
      flexDirection: "row",
    }
  };
});
